import { ROOT_FONT_SIZE, FONT_FAMILIES } from './constants';
import { createFluidTypography } from './helpers';

export default {
  htmlFontSize: ROOT_FONT_SIZE,
  h1: {
    fontFamily: FONT_FAMILIES.primary,

    fontWeight: 800,
    lineHeight: '40px',
    ...createFluidTypography(50, 35),
  },
  h2: {
    fontFamily: FONT_FAMILIES.primary,
    fontWeight: 800,
    lineHeight: '40px',
    ...createFluidTypography(40, 30),
  },
  h3: {
    fontFamily: FONT_FAMILIES.primary,
    fontWeight: 600,
    ...createFluidTypography(35, 24),
  },
  h4: {
    fontFamily: FONT_FAMILIES.primary,
    fontWeight: 400,
    ...createFluidTypography(25, 20),
  },
  h5: {
    fontFamily: FONT_FAMILIES.primary,
    fontWeight: 400,
    ...createFluidTypography(20, 18),
  },
  h6: {
    fontFamily: FONT_FAMILIES.primary,
    fontWeight: 400,
    ...createFluidTypography(16, 16),
  },
  body1: {
    fontFamily: FONT_FAMILIES.primary,
    letterSpacing: -0.36,
    fontWeight: 600,
    lineHeight: 'normal',
    ...createFluidTypography(16, 16),
  },
  body2: {
    fontFamily: FONT_FAMILIES.primary,
    letterSpacing: -0.32,
    fontWeight: 400,
    lineHeight: 'normal',
    ...createFluidTypography(16, 16),
  },
  subtitle1: {
    fontFamily: FONT_FAMILIES.primary,
    fontWeight: 400,
    lineHeight: 'normal',
    ...createFluidTypography(16, 16),
  },
  subtitle2: {
    fontFamily: FONT_FAMILIES.primary,
    fontWeight: 400,
    lineHeight: 'normal',
    ...createFluidTypography(14, 14),
  },
  button: {
    fontFamily: FONT_FAMILIES.primary,
    fontWeight: 600,
    lineHeight: 'normal',
    ...createFluidTypography(14, 14),
  },
  caption: {
    fontFamily: FONT_FAMILIES.primary,
    fontWeight: 400,
    lineHeight: 'normal',
    ...createFluidTypography(12, 12),
  },
  overline: {
    fontFamily: FONT_FAMILIES.primary,
    fontWeight: 400,
    letterSpacing: -0.32,
    lineHeight: 'normal',
    ...createFluidTypography(10, 0),
  },
};
